import React, {useMemo, useState, useCallback} from 'react';
import makeComp from '../../util/profiler';
import {envIsDev} from '../../config';

export interface PanelExportState {
  devMode: boolean;
  panels: any[];
}

// TODO: Default devMode here as a user setting (dev only)
//   wait why do we declare a default here, and in the Provider?
export const PanelExportContext = React.createContext<PanelExportState>({
  devMode: true,
  panels: [],
});

interface Updaters {
  addPanel(panel: any): void;
  setDevMode(enabled: boolean): void;
}

export const PanelExportUpdaterContext = React.createContext<Updaters>({
  addPanel: () => {},
  setDevMode: () => {},
});

export const PanelExportContextProvider: React.FC = makeComp(
  ({children}) => {
    const [devMode, setDevMode] = useState<boolean>(false);
    const [panels, setPanels] = useState<any[]>([]);
    const addPanel = useCallback(
      panel => setPanels(curPanels => [...curPanels, panel]),
      []
    );

    const state = useMemo<PanelExportState>(
      () => ({
        // force to off when in prod
        devMode: envIsDev && devMode,
        panels,
      }),
      [devMode, panels]
    );
    const updaters = useMemo<Updaters>(() => ({addPanel, setDevMode}), [
      addPanel,
      setDevMode,
    ]);

    return (
      <PanelExportContext.Provider value={state}>
        <PanelExportUpdaterContext.Provider value={updaters}>
          {children}
        </PanelExportUpdaterContext.Provider>
      </PanelExportContext.Provider>
    );
  },
  {id: 'PanelExportContextProvider', memo: true}
);
